<template>
  <vue-scroll :ops="ops">
    <v-app id="app" ref="app">

      <!-- headerナビゲーション -->
      <v-navbar-top v-if="isAuthenticated && !isAgreedPath"/>

      <!-- leftナビゲーション -->
      <div @click.stop="" v-if="isAuthenticated">
        <v-navbar-left class="navigation-drawer"></v-navbar-left>
      </div>

      <!-- loading -->
      <v-loading ref="loading"/>
        <v-main>
          <v-container fluid class="full-height px-16 signin-background">
            <router-view class="ml-2"></router-view>
          </v-container>
        </v-main>
    </v-app>
  </vue-scroll>
</template>

<script>
  import VNavbarTop from '@/components/organizms/NavbarTop'
  import VNavbarLeft from '@/components/organizms/NavbarLeft'
  import VLoading from '@/components/organizms/Loading'
  import VueScroll from 'vuescroll'

  export default {
    components: {
      VNavbarTop,
      VNavbarLeft,
      VLoading,
      VueScroll
    },
    data: () => ({
      ops: {
        bar: {
          background: 'gray',
        },
      }
    }),

    computed: {
      isAuthenticated() {
        return !!this.$store.state.user.accessToken
      },
      isAgreedPath() {
        return this.$store.state.currentPath.includes('agreed')
      },
      drawer() {
        return this.$store.state.drawer;
      }
    },

    methods: {
      // ipadで見たときに、ブラウザ上部のバーによって高さがずれるため調整
      setViewHeight() {
        this.$refs.app.$el.style['min-height'] = window.innerHeight + 'px'
      },
    },

    mounted() {
      //リサイズする度に高さ再調整
      window.addEventListener("resize", this.setViewHeight);
      this.setViewHeight()
      //デザインが崩れないように最小幅を設定
      this.$refs.app.$el.style['min-width'] = '965px'
      // タブ名を設定
      document.title = 'ゲットスルー2600システム';
    },

    beforeDestroy() {
      window.removeEventListener("resize", this.setViewHeight);
    },
  }
</script>


<style lang="stylus">
a
  text-decoration: none

.v-data-table-header
  background-color: #e5e5e5 !important

.list-th
  font-size: 14px !important

.list-td
  padding: 0 35px !important

.__bar-is-horizontal
  position: fixed !important
  top: initial !important
</style>

<style lang="stylus" scoped>
.signin-background
  height 100%
  background: url(./assets/img/mountains-5515324_1930.png) no-repeat top ;
  background-size: cover;
  position: relative;
  z-index: 0;
  overflow: hidden;

.signin-background:before
  content: '';
  background: inherit;
  -webkit-filter: blur(10px);
  -moz-filter: blur(10px);
  -o-filter: blur(10px);
  -ms-filter: blur(10px);
  filter: blur(40px);
  position: absolute;
  top: -5px;
  left: -5px;
  right: -5px;
  bottom: -5px;
  z-index: -1;

.header-logo
  margin: 0px;
  margin-bottom: 5px;
  position: relative;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);

.navigation-drawer
  height: calc(100% - 72px)!important;
  margin-top 72px;

</style>
